import { useEffect, useState } from "react";
import { ensureAnonAuth } from "../firebase";
import { loadPairings, addPairing, decodePairingPayload, type PairingPayload } from "../pairings";

/**
 * App boot: open the anonymous Firestore session, auto-pair from a `…/pair#cc1:…` deep link, and load the
 * stored pairings. Owns the `ready` / `err` / `pairings` state; the pairing add/remove/mirror handlers in
 * App drive the returned setters.
 */
export function useBoot() {
  const [ready, setReady] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [pairings, setPairings] = useState<PairingPayload[]>([]);

  useEffect(() => {
    ensureAnonAuth()
      .then(() => setReady(true))
      .catch((e) => setErr(String(e)));
    if (location.hash) {
      const p = decodePairingPayload(location.hash);
      if (p) {
        addPairing(p);
        history.replaceState(null, "", location.pathname);
      }
    }
    setPairings(loadPairings());
  }, []);

  return { ready, err, setErr, pairings, setPairings };
}
